import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IInvoice, ILogReport, ILogQuery } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class InvoiceService extends BaseService<IInvoice> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'invoice');
  }

  preProcess(data: any): any {
    if (Array.isArray(data)) {
      for (let d of data) {
        this.dateToLocal(d, 'date');
      }
    } else {
      this.dateToLocal(data, 'date');
    }
    return data;
  }

  getReport(data: ILogQuery): Observable<ILogReport[]> {
    let userFilter = this.accountService.getUserFilter();
    this.formatDateOnly(data, 'start');
    this.formatDateOnly(data, 'end');
    data = userFilter.updateObject(data);
    return this.http.post<any[]>(
      this.baseUrl + 'report',
      data,
      this.defaultOptions
    );
  }
}

export { IInvoice } from '../shared/api';
